import { InfoBox, Button } from '../Components';

const HomePage = () => (
  <InfoBox title='4oh4' subtitle="Looks like we're a little lost">
      <Button href='/scan'>Take me home</Button>
  </InfoBox>
);

export default HomePage;
